module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-Semibold-477b4b7c9d1814eba5351170b57ab044.woff2";